import { makeStyles } from '@material-ui/core/styles';

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      color: theme.palette.widgets.text.primary,
      fontSize: 13,
      fontWeight: 600,
      textTransform: 'capitalize',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      color: '#2C2C2E',
      fontSize: 12,
      fontWeight: 400,
      maxWidth: '60%',
      wordBreak: 'break-word',

      '& span:last-child': {
        display: 'block',
        color: theme.palette.widgets.text.primary,
        fontSize: 11,
        textTransform: 'capitalize',
      },
    },
  };
});

const listItemsStyles = makeStyles({
  root: {
    width: '100%',
    padding: '0 5px',
    borderBottom: '1px solid #EEE',
    marginBottom: 10,
  },
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      paddingLeft: 30,
      paddingRight: 30,
    },
  };
});

export { listTextStyles, customCardStyles, listItemsStyles };
